import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Spinner } from 'react-bootstrap';
import { getSite, updateSite } from '../../store/slices/project';
import { useDispatch } from 'react-redux';
import { useNavigate, Link, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const INITIAL_FORM = {
  plotNo: "",
  facing: "",
  dimension: "",
  areaSqft: "",
  status: "",
  plotPrice: "",
};

function FieldError({ msg }) {
  return <span className="apl-error-msg">{msg || ''}</span>;
}


const validateField = (key, value, form) => {


};

export default function EditSiteDetails() {

  const { id } = useParams();

  const [form, setForm] = useState(INITIAL_FORM);
  const [errors, setErrors] = useState({});


  const [submitLoading, setSubmitLoading] = useState(false);
  const [uploadingText, setUploadingText] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [globalError, setGlobalError] = useState('');

  const [pageLoading, setPageLoading] = useState(false);


  const dispatch = useDispatch();
  const navigate = useNavigate();



  useEffect(() => {
    if (!id) return;

    setPageLoading(true);

    dispatch(getSite({ id }))
      .then((res) => {
        const data = res?.payload?.data;

        if (!data) return;

        setForm({
          project: data.project?._id || "",
          plotNo: data.plotNo?.toString() || "",
          facing: data.facing || "",
          dimension: data.dimension || "",
          areaSqft: data.areaSqft?.toString() || "",
          status: data.status || "",
          plotPrice: data.plotPrice?.toString() || "",
        });
      })
      .finally(() => {
        setPageLoading(false);
      });
  }, [dispatch, id]);



  const handleChange = (key, value, section = null) => {
    console.log(key, value);
    setForm((prev) => {
      const next = section
        ? { ...prev, [section]: { ...prev[section], [key]: value } }
        : { ...prev, [key]: value };
      return next;
    });

    const errorKey = section ? `${section}.${key}` : key;

    const msg = validateField(errorKey, value, { ...form, ...(section ? { [section]: { ...form[section], [key]: value } } : {}) });

    setErrors((prev) => ({ ...prev, [errorKey]: msg }));
  };



  const handleSubmit = async () => {
    setSuccessMsg('');
    setGlobalError('');
    try {
      setSubmitLoading(true);

      const payload = {
        id,
        plotNo: Number(form.plotNo),
        facing: form.facing,
        dimension: form.dimension,
        areaSqft: Number(form.areaSqft),
        status: form.status,
        plotPrice: Number(form.plotPrice),
      };

      await dispatch(updateSite(payload));

      const response = await dispatch(updateSite(payload));

      if (response?.payload || response?.type?.includes('fulfilled')) {
        setSuccessMsg('Project updated successfully!');
        setForm(INITIAL_FORM);

      }
      toast.success('Site updated successfully!');
      navigate(-1);
    } catch (err) {
      const errMsg = err?.message || err || 'Something went wrong. Please try again.';
      setGlobalError(errMsg);
      toast.error(errMsg);
    } finally {
      setSubmitLoading(false);
      setUploadingText('');
    }
  };

  return (
    <>
      <div className="breadcrumb-bar  mx-1">
        <div className="container-fluid">
          <div className="d-flex flex-row align-items-center justify-content-between gap-2 py-2">
            <div className="breadcrumb-left d-flex align-items-center flex-wrap">
              <Link to="/admin/home" className="breadcrumb-link active">
                Home
              </Link>
              <span className="breadcrumb-separator mx-2">
                <i className="bi bi-chevron-right"></i>
              </span>
              <Link onClick={() => navigate(-1)} className="breadcrumb-link active">
                Sites
              </Link>
              <span className="breadcrumb-separator mx-2">
                <i className="bi bi-chevron-right"></i>
              </span>
              <span className="breadcrumb-link inactive">
                Edit Site
              </span>
            </div>

          </div>
        </div>
      </div>

      <div className="ud-page-wrap">
        <Container fluid>
          <div className="ud-header">
            <h2 className="ud-main-title">Edit Site</h2>

          </div>


          <div className="global-card">

            <Row className="g-3">


              <Col xs={12} sm={6} lg={4}>
                <Form.Group>
                  <label className="apl-label">Plot No</label>
                  <input
                    className="global-input"
                    value={form.plotNo}
                    onChange={(e) =>
                      handleChange(
                        "plotNo",
                        e.target.value.replace(/[^0-9]/g, "")
                      )
                    }
                  />
                </Form.Group>
              </Col>

              <Col xs={12} sm={6} lg={4}>
                <Form.Group>
                  <label className="apl-label">Facing</label>

                  <Form.Select
                    className="global-input"
                    value={form.facing}
                    onChange={(e) => handleChange("facing", e.target.value)}
                  >
                    <option value="">Select Facing</option>
                    <option value="EAST">East</option>
                    <option value="WEST">West</option>
                    <option value="NORTH">North</option>
                    <option value="SOUTH">South</option>
                    <option value="NORTH_EAST">North East</option>
                    <option value="NORTH_WEST">North West</option>
                    <option value="SOUTH_EAST">South East</option>
                    <option value="SOUTH_WEST">South West</option>
                  </Form.Select>

                  <FieldError msg={errors.facing} />
                </Form.Group>
              </Col>

              <Col xs={12} sm={6} lg={4}>
                <Form.Group>
                  <label className="apl-label">Dimension</label>
                  <input
                    className="global-input"
                    placeholder="e.g. 30X40"
                    value={form.dimension}
                    onChange={(e) =>
                      handleChange("dimension", e.target.value)
                    }
                  />
                </Form.Group>
              </Col>

              <Col xs={12} sm={6} lg={4}>
                <Form.Group>
                  <label className="apl-label">Area (Sq Ft)</label>
                  <input
                    className="global-input"
                    value={form.areaSqft} maxLength={5}
                    onChange={(e) =>
                      handleChange(
                        "areaSqft",
                        e.target.value.replace(/[^0-9]/g, "")
                      )
                    }
                  />
                </Form.Group>
              </Col>

              <Col xs={12} sm={6} lg={4}>
                <Form.Group>
                  <label className="apl-label">Status</label>
                  <Form.Select
                    className="global-input"
                    value={form.status}
                    onChange={(e) =>
                      handleChange("status", e.target.value)
                    }
                  >
                    <option value="">Select Status</option>
                    <option value="Available">Available</option>
                    <option value="Booked">Booked</option>
                    <option value="Sold">Sold</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col xs={12} sm={6} lg={4}>
                <Form.Group>
                  <label className="apl-label">Plot Price</label>
                  <input
                    className="global-input"
                    value={form.plotPrice} maxLength={8}
                    onChange={(e) =>
                      handleChange(
                        "plotPrice",
                        e.target.value.replace(/[^0-9]/g, "")
                      )
                    }
                  />
                </Form.Group>
              </Col>
            </Row>
          </div>


          <div className="d-flex flex-column justify-content-center flex-sm-row align-items-sm-center gap-3 mt-2 mb-4 ">
            <div className="action-seciton gap-3 mb-5 ">
              <button
                type="button"
                className="global-cancel-btn"
                onClick={() => navigate(-1)}
                disabled={submitLoading}
              >
                Cancel
              </button>

              <button
                type="button"
                className="global-submit-btn"
                onClick={handleSubmit}
                disabled={submitLoading}
              >
                {submitLoading ? (
                  <span className="d-flex align-items-center gap-2">
                    <Spinner animation="border" size="sm" />
                    {uploadingText || 'Saving…'}
                  </span>
                ) : (
                  'Submit'
                )}
              </button>
            </div>
          </div>

        </Container>
      </div>
    </>
  );
}